import { render, staticRenderFns } from "./TipoDeduccion.vue?vue&type=template&id=4aa64ae0&scoped=true"
import script from "./TipoDeduccion.vue?vue&type=script&lang=js"
export * from "./TipoDeduccion.vue?vue&type=script&lang=js"
import style0 from "./TipoDeduccion.vue?vue&type=style&index=0&id=4aa64ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa64ae0",
  null
  
)

export default component.exports